module.exports = __webpack_public_path__ + "img/hotel-da-estrela.e24dcdf5.jpg";